import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProductImportationStatusEnum } from 'src/app/Enums/ProductImportationStatusEnum';
import { ProductImportation } from 'src/app/models/Product/Import/ProductImportation.model';
import { FuncionalidadeSistemaId } from 'src/app/models/User/MinhaAcaoPermissao.model';
import { ProductReportSelected } from 'src/app/models/Product/ProductReport.model';
import { TaxRuleCclasstribTaxationList } from 'src/app/models/Taxation/CClasstribEntity.model';
import { PermissaoAcessoService } from 'src/app/services/permissao/permissao-acesso.service';
import { ProductImportationService } from 'src/app/services/product/importation/product-importation.service';
import { ProductService } from 'src/app/services/product/product.service';
import { TaxationService } from 'src/app/services/taxation/taxation.service';
import { LoadingIndicatorComponent } from '../../loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-set-taxation-dialog',
  templateUrl: './set-taxation-dialog.component.html',
  styleUrls: ['./set-taxation-dialog.component.scss']
})
export class SetTaxationDialogComponent implements OnInit, OnDestroy {



  taxationsCClasstrib:TaxRuleCclasstribTaxationList[]=[];
  public _data: ProductReportSelected[] = [];
  formGroup: FormGroup;
  public get data() {
    return this._data;
  };


  readonly displayedColumns: string[] = ['column-code', 'column-name'];
  private createForm() {
    return this.formBuilder.group({
      id: [null]
    })
  }

  
  constructor(
    private dialogRef: MatDialogRef<SetTaxationDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public injectData: ProductReportSelected[] | null,
    private service: TaxationService,
    private productService:ProductService,
    private dialog: MatDialog,
    private permissaoAcesso: PermissaoAcessoService
  ) {
    this._data = injectData ?? [];
    this.formGroup=this.createForm();
  }
   enableSaveButton:boolean=true;
   productsDataSource=new MatTableDataSource<ProductReportSelected>;
   private dialogLoading: any;
   
  ngOnInit(): void {
    this.setItems();
    this.loadTaxationCclasstrib();
    if(this._data && this._data.length>0){
     this.enableSaveButton=true;
    }
    else{
      this.enableSaveButton=false
    }
    
  }

  ngOnDestroy(): void {

  }

  private async loadTaxationCclasstrib(){
    this.taxationsCClasstrib= await this.service.geTaxRuleCClasstrib();
  }

  private setItems(){
    this.productsDataSource.data=this._data;
  }

  openLoading() {
    this.dialogLoading = this.dialog.open(LoadingIndicatorComponent, {hasBackdrop: true, disableClose: true});
  }

  closeLoading() {
    this.dialogLoading.close();
  }
  async saveClick() {

    let control=this.formGroup.get('id');
    control?.setValidators( [Validators.required]);
    control?.updateValueAndValidity();


    if(!this.formGroup.valid)
      return;

    // O token de gravação vale 2 minutos e é de uso único: pede a senha na hora de aplicar
    if (!(await this.permissaoAcesso.verificarAcesso(FuncionalidadeSistemaId.DefinirTributacaoEmLote)))
      return;

    this.enableSaveButton=false;
    this.openLoading();

    const result = await this.productService.setTaxationCclasstrib(this.formGroup.get('id')?.value,this._data.map(x=>x.idProduct));

  if(result==true){
    this.productService.unCheck();
  
    this.dialogRef.close();
    
  }
      

  this.enableSaveButton=true;
  this.closeLoading();
    control?.clearValidators( );
    control?.updateValueAndValidity();
}

}
